import { useState } from "react";
import { supabase } from "../../lib/supabase";
import { useAsyncHandler } from "../../hooks/useAsyncHandler";

interface UseForgotPasswordResult {
  email: string;
  setEmail: (v: string) => void;
  sent: boolean;
  error: string | null;
  loading: boolean;
  handleSubmit: (e: React.FormEvent) => void;
}

/** Sends a Supabase password-reset email pointing back to /reset-password. */
export function useForgotPassword(): UseForgotPasswordResult {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const { loading, error, handle } = useAsyncHandler(async () => {
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    if (resetError) throw new Error(resetError.message);
    setSent(true);
  });

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    void handle();
  }

  return { email, setEmail, sent, error, loading, handleSubmit };
}
